import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import { environment } from '../../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  private  apiUrl =  environment.apiUrlHistory;
  private  apiKey = environment.apiKey;


  constructor(
    private router: Router,
    private http: HttpClient
  ) {
  }

  getHistory(params) {
    const header = new HttpHeaders()
      .set('x-api-key', `${this.apiKey}`);
    return this.http.get(`${this.apiUrl}/get_history_my_purchases`, {params: params , headers: header});

  }


  // setComplaint

  setComplaint(formData) {
    const header = new HttpHeaders()
      .set('x-api-key', `${this.apiKey}`);
    return this.http.post(`${this.apiUrl}/set_complaint`, formData, {headers: header});
  }



  getTransaction(params) {
    const header = new HttpHeaders()
      .set('x-api-key', `${this.apiKey}`);
    return this.http.get(`${this.apiUrl}/get-history`, {params: params , headers: header});

  }

}
